import { Injectable } from '@angular/core';
import { isNotNil } from '@gelato-api-ui/utils/ramda';
import { ETaskResponse } from '@api-ui-app/src/app/e-commerce-framed-posters-upgrade/types/e-task-response';
import {
  PriceNavigatorDraftPrices,
  PriceNavigatorItemModel,
} from '@api-ui-app/src/app/price-navigator/prices/types/price-navigator.types';

@Injectable({
  providedIn: 'root',
})
export class PriceNavigatorPublishPricesService {
  static setDraftPrices(
    draftPricesToChange: PriceNavigatorDraftPrices[],
    payload: PriceNavigatorDraftPrices[],
  ): PriceNavigatorDraftPrices[] {
    return [...draftPricesToChange]
      .filter(
        oldPrice =>
          !payload.some(newPrice => {
            // compare productUids in case of handling draft prices where variantId is not set
            return newPrice.variantId && oldPrice.variantId
              ? newPrice.variantId === oldPrice.variantId
              : newPrice.productUid === oldPrice.productUid;
          }),
      )
      .concat(payload);
  }

  static patchProductPrices(
    initialProductPrices: PriceNavigatorItemModel[],
    publishedPrices: ETaskResponse[],
    draftPrices: PriceNavigatorDraftPrices[],
  ): PriceNavigatorItemModel[] {
    try {
      const publishedProductIds = publishedPrices.map(({ parameters }) => {
        const parsedParameters = JSON.parse(parameters);
        return parsedParameters?.productIds?.[0];
      });

      return initialProductPrices.map(product => ({
        ...product,
        variants: publishedProductIds.includes(product.id)
          ? product.variants.map(variant => {
              const publishedVariant = draftPrices.find(({ variantId }) => variantId === variant.id);
              return publishedVariant
                ? {
                    ...variant,
                    retailPrice: isNotNil(publishedVariant.newRetailPrice)
                      ? publishedVariant.newRetailPrice
                      : variant.retailPrice,
                    compareAtPrice: isNotNil(publishedVariant.newCompareAtPrice)
                      ? publishedVariant.newCompareAtPrice
                      : variant.compareAtPrice,
                  }
                : variant;
            })
          : product.variants,
      }));
    } catch (e) {
      return initialProductPrices;
    }
  }
}
